<template>
    <div>
        <v-container grid-list-lg fluid>
            <v-layout row wrap>
                <v-flex lg12 md12 sm12>
                    <v-layout row wrap>
                        <v-flex lg3 md12 sm12 pr-6 pl-lg-6>
                            <v-layout row wrap justify-end>
                                <v-menu v-model="menuStart" :close-on-content-click="false"
                                    transition="scale-transition" offset-y max-width="290px" min-width="290px">
                                    <template v-slot:activator="{ on }">
                                        <v-text-field v-model="computedStartDateFormatted" label="Từ ngày"
                                            hint="DD-MM-YYYY" persistent-hint prepend-icon="fa-calendar-alt" readonly
                                            v-on="on"></v-text-field>
                                    </template>
                                    <v-date-picker v-model="dateRange.startDate" no-title
                                        @input="menuStart = false"></v-date-picker>
                                </v-menu>
                            </v-layout>
                        </v-flex>
                        <v-flex lg3 md12 sm12 pr-6>
                            <v-layout row wrap justify-end>
                                <v-menu v-model="menuEnd" :close-on-content-click="false" transition="scale-transition"
                                    offset-y max-width="290px" min-width="290px">
                                    <template v-slot:activator="{ on }">
                                        <v-text-field v-model="computedEndDateFormatted" label="Đến ngày"
                                            hint="DD-MM-YYYY" persistent-hint prepend-icon="fa-calendar-alt" readonly
                                            v-on="on"></v-text-field>
                                    </template>
                                    <v-date-picker v-model="dateRange.endDate" no-title
                                        @input="menuEnd = false"></v-date-picker>
                                </v-menu>
                            </v-layout>
                        </v-flex>
                        <v-flex lg3 md12 sm12 pr-6>
                            <v-btn @click="filter_data(0)" color="#a77800" outlined>Lọc dữ liệu</v-btn>
                        </v-flex>
                    </v-layout>
                </v-flex>

                <v-flex lg12>
                    <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter"
                        v-on:quickFilter="quickFilter"></hpo-filter>
                    <v-data-table :headers="headers" :items="items" :options.sync="pagination"
                        :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true"
                        :loading="loading" :mobile-breakpoint="100">
                        <template v-slot:item="{ item }">
                            <tr>
                                <td>{{ item.ReportDate }}</td>
                                <td>{{ item.BuyerID | display_value(staffs, 'ID', 'FullName') }}</td>
                                <td>{{ item.CustomerServiceID | display_value(staffs, 'ID', 'FullName') }}</td>
                                <td>{{ item.SalerID | display_value(staffs, 'ID', 'FullName') }}</td>
                                <td>{{ item.Username }}</td>
                                <td>{{ (item.OrderType == 1 ? 'MD' : 'KG') + item.ID }}</td>
                                <td>{{ item.OrderType == 1 ? 'Mua hộ' : 'Ký gửi' }}</td>
                                <td :style="{'color': item.LineType == 1 ? 'blue' : 'orange'}">{{ item.LineType == 1 ? 'CN' : 'TN' }}</td>
                                <td class="text-end">{{ item.AmountCNY | currency('', 2) }}</td>
                                <td class="text-end">{{ item.TotalRealAmountCNY | currency('', 2) }}</td>
                                <td class="text-end">{{ item.ExchangeRateIn | currency }}</td>
                                <td class="text-end">{{ item.ExchangeRate | currency }}</td>
                                <td class="text-end">{{ item.FeeBuyAmount | currency }}</td>
                                <td class="text-end">{{ item.RealAmountRevenue | currency }}</td>
                                <td class="text-end">{{ item.ExchangeRevenue | currency }}</td>
                                <td class="text-end">{{ item.FeeWeightRevenue | currency }}</td>
                                <td class="text-end">{{ item.FeeEntrust | currency }}</td>
                                <td class="text-end">{{ item.ImportTaxAmount | currency }}</td>
                                <td class="text-end">{{ item.VatTaxAmount | currency }}</td>
                                <td class="text-end">{{ item.TotalWeight | currency('', 1) }}</td>
                                <td class="text-end">{{ item.TotalVolume | currency('', 2) }}</td>
                                <td class="text-end">{{ item.Deposit | currency }}</td>
                                <td class="text-end">{{ item.RemainAmount | currency }}</td>
                                <td v-bind:style="{ 'color': display_color(item.Status, order_statuses) }">{{ item.Status
                                    | display_value(order_statuses)}}</td>
                            </tr>
                        </template>
                        <template v-slot:body.append v-if="summary">
                            <tr>
                                <td class="font-weight-bold" colspan="8">TỔNG DOANH SỐ</td>
                                <td class="font-weight-bold text-end">{{ summary.AmountCNY | currency('¥', 2) }}</td>
                                <td class="font-weight-bold text-end">{{ summary.TotalRealAmountCNY | currency('¥', 2)
                                    }}</td>
                                <td class="font-weight-bold text-end"></td>
                                <td class="font-weight-bold text-end"></td>
                                <td class="font-weight-bold text-end">{{ summary.FeeBuyAmount | currency }}</td>
                                <td class="font-weight-bold text-end">{{ summary.RealAmountRevenue | currency }}</td>
                                <td class="font-weight-bold text-end">{{ summary.ExchangeRevenue | currency }}</td>
                                <td class="font-weight-bold text-end">{{ summary.FeeWeightRevenue | currency }}</td>
                                <td class="font-weight-bold text-end">{{ summary.FeeEntrust | currency }}</td>
                                <td class="font-weight-bold text-end">{{ summary.ImportTaxAmount | currency }}</td>
                                <td class="font-weight-bold text-end">{{ summary.VatTaxAmount | currency }}</td>
                                <td class="font-weight-bold text-end">{{ summary.TotalWeight | currency('', 1) }}</td>
                                <td class="font-weight-bold text-end">{{ summary.TotalVolume | currency('', 2) }}</td>
                                <td class="font-weight-bold text-end">{{ summary.Deposit | currency }}</td>
                                <td class="font-weight-bold text-end">{{ summary.RemainAmount | currency }}</td>
                                <td class="font-weight-bold text-end"></td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>
<script>
import Filtering from "@/components/Filtering";
import { mapState } from "vuex";
import configs from "@/configs";
import _ from "lodash";
import moment from "moment"
export default {
    components: {
        "hpo-filter": Filtering
    },
    data() {
        return {
            viewName: "bao-cao-doanh-thu",
            dialogDetail: false,
            display_color: this.$options.filters.display_color,
            filterType: 0,
            filterOrder: [],
            dateRange: {
                startDate: moment.utc(Date.now()).startOf('month').toISOString().substr(0, 10),
                endDate: moment.utc(Date.now()).endOf('month').toISOString().substr(0, 10),
            },
            menuStart: false,
            menuEnd: false,
            selectedDateType: 1,
            order_statuses: configs.ORDER_STATUS,
            pagination: { ...configs.PAGINATION, sortBy: ["ReportDate"] },
            items_per_page: { ...configs.ITEMS_PER_PAGE },
            filterConditions: [],
            quickFilterConditions: [],
        };
    },
    watch: {
        pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                this.filter_data();
            },
            deep: true
        },
        staffs() {
            let header_item = _.find(this.headers, { value: "BuyerID" });
            if (header_item) {
                header_item.values = _.map(this.staffs, (item) => {
                    return {
                        value: item.ID,
                        name: item.FullName
                    }
                }) || []
            }
            header_item = _.find(this.headers, { value: "CustomerServiceID" });
            if (header_item) {
                header_item.values = _.map(this.staffs, (item) => {
                    return {
                        value: item.ID,
                        name: item.FullName
                    }
                }) || []
            }
            header_item = _.find(this.headers, { value: "SalerID" });
            if (header_item) {
                header_item.values = _.map(this.staffs, (item) => {
                    return {
                        value: item.ID,
                        name: item.FullName
                    }
                }) || []
            }
        },
    },
    computed: {
        ...mapState({
            items: state => state.report.orderRevenueV2.data,
            total_rows: state => state.report.orderRevenueV2.total,
            summary: state => state.report.orderRevenueV2.summary,
            loading: state => state.report.loading,
            staffs: state => state.commons.all_users,
        }),
        computedStartDateFormatted() {
            return moment(this.dateRange.startDate).format(configs.SHORT_DATE_FORMAT);
        },
        computedEndDateFormatted() {
            return moment(this.dateRange.endDate).format(configs.SHORT_DATE_FORMAT);
        },
        adminRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
        },
        tableConfig() {
            return {
                pagination: this.pagination,
                filter: this.filterConditions,
                quickFilter: this.quickFilterConditions
            }
        },
        headers() {
            return [
                {
                    text: "Thời gian",
                    value: "ReportDate",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Date"]
                },
                {
                    text: "Mua hàng",
                    value: "BuyerID",
                    filterable: true,
                    values: [],
                    dataType: configs.DATA_TYPE["Enum"]
                },
                {
                    text: "CSKH",
                    value: "CustomerServiceID",
                    filterable: true,
                    values: [],
                    dataType: configs.DATA_TYPE["Enum"]
                },
                {
                    text: "Sale",
                    value: "SalerID",
                    filterable: true,
                    values: [],
                    dataType: configs.DATA_TYPE["Enum"]
                },
                {
                    text: "Mã KH",
                    value: "Username",
                    filterable: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Đơn hàng",
                    value: "ID",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Loại đơn",
                    value: "OrderType",
                    filterable: true,
                    values: [{ 'value': 1, 'name': 'Mua hộ' }, { 'value': 2, 'name': 'Ký gửi' }],
                    dataType: configs.DATA_TYPE["Enum"]
                },
                {
                    text: "Line hàng",
                    value: "LineType",
                    filterable: true,
                    values: [{ 'value': 0, 'name': 'Tiểu ngạch' }, { 'value': 1, 'name': 'Chính ngạch' }],
                    dataType: configs.DATA_TYPE["Enum"]
                },
                {
                    text: "Tiền hàng (¥)",
                    value: "AmountCNY",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Mua thật (¥)",
                    value: "TotalRealAmountCNY",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Tỷ giá mua",
                    value: "ExchangeRateIn",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Tỷ giá bán",
                    value: "ExchangeRate",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Phí dịch vụ",
                    value: "FeeBuyAmount",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Chênh tiền mua",
                    value: "RealAmountRevenue",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Chênh tỷ giá",
                    value: "ExchangeRevenue",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Doanh thu VC",
                    value: "FeeWeightRevenue",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Phí ủy thác",
                    value: "FeeEntrust",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Thuế nhập khẩu",
                    value: "ImportTaxAmount",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Thuế VAT",
                    value: "VatTaxAmount",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Kg",
                    value: "TotalWeight",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "M3",
                    value: "TotalVolume",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Đã TT",
                    value: "Deposit",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Chưa TT",
                    value: "RemainAmount",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Trạng thái",
                    value: "Status",
                    filterable: true,
                    values: configs.ORDER_STATUS,
                    dataType: configs.DATA_TYPE["Enum"]
                },
            ];
        }
    },
    methods: {
        filter_data: function (type) {
            var param = {
                ...this.tableConfig,
                startTime: moment(this.dateRange.startDate).format(configs.SQL_DATE_FORMAT),
                endTime: moment(this.dateRange.endDate).format(configs.SQL_DATE_FORMAT)
            };
            this.$store.dispatch("report/getOrderRevenueV2Report", param);
        },
        applyFilter(filterConditions) {
            let sortBy = this.pagination.sortBy
            let sortDesc = this.pagination.sortDesc
            this.pagination = configs.PAGINATION;
            this.pagination.sortBy = sortBy;
            this.pagination.sortDesc = sortDesc;
            this.filterConditions = filterConditions;
            this.filter_data();
        },
        quickFilter(filterConditions) {
            this.quickFilterConditions = filterConditions;
            this.filter_data();
        },
        export_data() {
            var param = {
                ...this.tableConfig,
                startTime: moment(this.dateRange.startDate).format(configs.SQL_DATE_FORMAT),
                endTime: moment(this.dateRange.endDate).format(configs.SQL_DATE_FORMAT)
            };
            this.$store.dispatch("report/exportOrderRevenueV2Report", param);
        }
    },
    mounted() {
        this.$store.dispatch("commons/getAllUsers");
        this.filter_data();
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$on("REQUEST_CREATE_DATA", this.export_data);
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$off("REQUEST_CREATE_DATA");
    }
};
</script>
<style scoped>
.rate-p {
    margin-bottom: 0px;
    margin-top: 16px;
}

.rate-p2 {
    margin-bottom: 16px;
    margin-top: 8px;
    color: rgb(168, 168, 168);
}
</style>